import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Button } from 'react-wot-bootstrap'
import NavigationArrow from 'components/NavigationArrow/NavigationArrow'
import Paging from './components/Paging/Paging'

import { NEXT, TO_STRONGHOLD } from './translations'

import styles from './Slider.scss'

export default class Slider extends React.Component {
    static propTypes = {
        children: PropTypes.arrayOf(PropTypes.node),
        handleClose: PropTypes.func.isRequired,
        classNames: PropTypes.shape({
            paging: PropTypes.string,
            navContainer: PropTypes.string,
            buttonContainer: PropTypes.string,
        }),
    }
    constructor(props) {
        super(props)
        this.state = {
            activeSlide: 1,
        }
    }

    handleNextClick = () => {
        this.setState({
            activeSlide: this.state.activeSlide + 1,
        })
    }

    handlePrevClick = () => {
        this.setState({
            activeSlide: this.state.activeSlide - 1,
        })
    }

    render() {
        const { activeSlide } = this.state
        const { classNames, children } = this.props

        const isPrevNavDisabled = (activeSlide === 1)
        const isNextNavDisabled = (activeSlide === children.length)

        return (
            <div className={styles.base}>
                <div className={cx(styles.navigation, classNames.navContainer)}>
                    <NavigationArrow
                        type='left'
                        handleClick={this.handlePrevClick}
                        disabled={isPrevNavDisabled}
                    />
                    <NavigationArrow
                        type='right'
                        handleClick={this.handleNextClick}
                        disabled={isNextNavDisabled}
                    />
                </div>
                <div className={styles.content} key={activeSlide}>
                    <Paging
                        className={cx(styles.paging, classNames.paging)}
                        currentPage={activeSlide}
                        totalPages={children.length}
                    />
                    {this.props.children[activeSlide - 1]}
                    <div className={cx(styles.button, classNames.buttonContainer)}>
                        {isNextNavDisabled ? (
                            <Button onClick={this.props.handleClose}>{TO_STRONGHOLD}</Button>
                        ) : (
                            <Button onClick={this.handleNextClick}>{NEXT}</Button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/MigrationScreen/components/Slider/Slider.jsx